/**
 * Only same-app absolute paths are valid in-app targets (no open redirect):
 * must start with "/", never "//" or "/\" (protocol-relative), never back
 * into /sign-in. Anything else → "/".
 */
export function safeReturnTo(raw: string | null | undefined): string {
  if (!raw || !raw.startsWith("/") || raw.startsWith("//") || raw.startsWith("/\\")) return "/";
  if (raw.startsWith("/sign-in")) return "/";
  return raw;
}

/** True when `path` is itself a safe in-app path. */
export function isSafeAppPath(path: string | null | undefined): path is string {
  return !!path && safeReturnTo(path) === path;
}

/** Where the verify screen goes when `returnTo` is missing, unsafe or itself the verify screen. */
export const VERIFY_FALLBACK = "/account/profile";
export const VERIFY_PATH = "/account/verify";

/**
 * W-7: `returnTo` for `/account/verify`. `safeReturnTo` plus: unsafe or
 * missing input (which `safeReturnTo` turns into "/") and any
 * `/account/verify*` target fall back to Profile, so the screen can't loop.
 */
export function verifyReturnTo(raw: string | null | undefined): string {
  const safe = safeReturnTo(raw);
  if (safe === "/" && raw !== "/") return VERIFY_FALLBACK;
  let pathname: string;
  try {
    // The router decodes paths (`/account/%76erify` = `/account/verify`).
    pathname = decodeURIComponent(new URL(safe, "http://app.invalid").pathname).toLowerCase();
  } catch {
    return VERIFY_FALLBACK;
  }
  if (pathname === VERIFY_PATH || pathname.startsWith(`${VERIFY_PATH}/`)) return VERIFY_FALLBACK;
  return safe;
}
